import { render } from "./SouthAfrica.vue?vue&type=template&id=4119880a&scoped=true"
import script from "./SouthAfrica.vue?vue&type=script&lang=js"
export * from "./SouthAfrica.vue?vue&type=script&lang=js"

import "./SouthAfrica.vue?vue&type=style&index=0&id=4119880a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4119880a"]])

export default __exports__